import { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import PageApp from '../../../Page';
import ModalEdit from './Edit'
import { HomeOutlined, UnorderedListOutlined, ClockCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import { Table, Empty, Modal, Divider, Button, message, Space, Tag } from 'antd';
import { getAll, drop } from '../../../../apis/RegistroPatronalApi';
import _ from 'lodash'
const { confirm } = Modal;

const routes = [{
  href: '',
  title: <>
    <HomeOutlined />
    <span>Inicio</span>
  </>,
},
{
  href: '',
  title: (
    <>
      <UnorderedListOutlined />
      <span>Catálogos</span>
    </>
  ),
},
{
  href: '',
  title: (
    <>
      <UnorderedListOutlined />
      <span>Registro Patronal</span>
    </>
  ),
}];

const RegistroPatronalPage = () => {
  let navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [openEdit, setOpenEdit] = useState(false);
  const [objectSelected, setObjectSelected] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openUploadFiles, setOpenUploadFiles] = useState(false);

  const openUploadModal = async (object) => {
    setObjectSelected(object);
    setOpenUploadFiles(true);
  }

  const columns = [
    {
      title: 'Clave Patronal',
      dataIndex: 'clave_patronal',
      key: 'clave_patronal',
    },
    {
      title: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
    },
    {
      title: 'RFC',
      dataIndex: 'rfc',
      key: 'rfc',
    },
    {
      title: 'Actividad Economica',
      dataIndex: 'actividad_economica',
      key: 'actividad_economica',
    },
    {
      title: '',
      dataIndex: 'actions',
      key: 'actions',
      render: (item, object) => {
        return <Space>
          <Button type='primary' size='small' onClick={() => {
            openDetails(object);
          }}>Editar</Button>
          {/* <Button type='default' size='small' onClick={() => openUploadModal(object)}
          >Subir Certificados</Button> */}
          <Button type='primary' size='small' danger onClick={() => {
            deleteConfirm(object);
          }}>Eliminar</Button>
        </Space>
      }
    }
  ];

  const openDetails = async (object) => {
    setOpenEdit(true);
    setObjectSelected(object);
  }

  const deleteConfirm = async (item) => {
    confirm({
      title: '¿Confirmas en el Registro Patronal?',
      icon: <ExclamationCircleFilled />,
      content: 'No podrás recuperar su información',
      onOk: () => { deleteOk(item.id) },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const deleteOk = async (id) => {
    const response = await drop(id);
    if (response.ok) {
      message.success('¡El Registro Patronal ha sido eliminada!');
    }
    await refreshData();
  }

  const btnClick = () => {
    setOpenEdit(true);
    setObjectSelected(null);
  }

  const onHandlerFinish = async (refresh) => {
    setOpenEdit(false);
    if (refresh) {
      await refreshData();
    }
  }

  const refreshData = async () => {
    const response = await getAll();
    if (response.ok) {
      let items = response.payload;
      setItems(items);
    }

    setLoading(false);
  }

  const effectRan = useRef(false);
  useEffect(() => {

    if (!effectRan.current) {
      (async () => {
        await refreshData();
      })();
    }

    return () => effectRan.current = true;
  }, []);

  return <PageApp routes={routes}
    title={'Registros Patronales'}
    cardTitle='Lista de registros'
    extraCard={[
      <Button type="primary" onClick={btnClick}>
        Agregar Registro Patronal
      </Button>
    ]}>
    {
      loading ? (
        <p>Loading...</p>
      ) : <>
        {
          items.length == 0 ? <Empty /> :
            <Table dataSource={items} columns={columns} />
        }
      </>
    }
    {
      (openEdit && objectSelected && objectSelected.id > 0) &&
      <ModalEdit title={"Editar Registro Patronal"} id={objectSelected.id} clavePatronal={objectSelected.clave_patronal} open={openEdit} finish={onHandlerFinish} />
    }
    {
      (openEdit && !objectSelected) &&
      <ModalEdit title={"Crear Registro Patronal"} open={openEdit} finish={onHandlerFinish} />
    }
        {/* {
      (openUploadFiles && objectSelected) &&
      <ModalUploadFiles 
        title={`Subir Certificados`}
        open={openUploadFiles}
        finish={(refresh) => {
          setOpenUploadFiles(false);
          if(refresh) refreshData();
        }}
        data={objectSelected}
      />
    } */}
  </PageApp>
}

export default RegistroPatronalPage;
